import React from "react";
import Router from "./Routes";
import "./App.css";
import "./styles.scss";

function App() {

  return (
    <div className="app-main">
      <Router />
    </div>
  );
}

export default App;
